import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/dealer');

export default {
    get () {
        return api.get('/');
    },
    getAccountCredit () {
        return api.get('/account-credit');
    },
    getDashboardStats () {
        return api.get('/dashboard-stats');
    },
    async postStripeAttachSource(source) {
        return (await api.post('/stripe-attach-source', { source : source })).data.customer_token;
    },
    async postStripeVerifyACH(data) {
        return (await api.post('/stripe-verify-ach', data)).data.verified;
    },
    postBasicInfo (dealerId, data) {
        return api.post(`/${dealerId}/basic`, data);
    },
    postUpdatePassword (data) {
        return api.post(`/update-password`, data);
    },
}
